import { ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation } from '@angular/core';
import { SettingsMap } from '@partners/settings';
import { ShellStore } from '@partners/state';
import { ThemeAssetComponent, TIconSet } from '@partners/themes';
import { TCssTuple, TResponsiveSize } from '../../model';

@Component({
  selector: 'icon',
  standalone: true,
  imports: [ThemeAssetComponent],
  template: `
    <theme-asset [asset]="iconName()" [iconSet]="iconSet()" [loadViaHttp]="loadViaHttp()"></theme-asset>
  `,
  styles: ``,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'hostClassList()',
    '[style]': 'responsiveSize()'
  }
})
export class IconComponent {
  #shellStore = inject(ShellStore);

  loadViaHttp = input<boolean>(false);
  iconName = input<string>();
  widthHeight = input<TCssTuple>();
  iconSize = input<TResponsiveSize>();
  responsiveWidth = input<boolean>(false);
  responsiveHeight = input<boolean>(false);

  iconVariant = input<'rounded' | 'default'>('default');

  responsiveSize = computed(() => {
    if (this.iconSize()) {
      return '';
    }
    if (this.responsiveHeight()) {
      return `height:100%;max-width:100%`;
    }
    return `width:100%;max-height:100%`;
  });

  iconSet = computed<TIconSet | undefined>(() => {
    const { partner } = this.#shellStore?.params$$();
    return SettingsMap.themeSettings(partner).iconSet;
  });

  hostClassList = computed<string>(() => {
    const defaultClasses = `icon icon--${this.iconVariant()} icon--${this.iconSet()}`;
    if (this.iconSize()) {
      return `${defaultClasses} icon--${this.iconSize()}`;
    }
    return defaultClasses;
  });
}
